<script lang='ts'>
import { CHANGE_EVENT } from 'element-plus'
import { computed, defineComponent, provide, ref, watch } from 'vue'

export default defineComponent({
  name: 'MsSteps',
  props: {
    space: {
      type: [Number, String],
      default: '',
    },
    direction: {
      type: String,
      default: 'vertical',
      validator: (val: string): boolean => {
        return ['validator', 'horizontal'].includes(val)
      },
    },
    active: {
      type: Number,
      default: 0,
    },
    finishStatus: {
      type: String,
      default: 'finish',
      validator: (val: string): boolean =>
        ['wait', 'process', 'finish', 'error', 'success'].includes(val),
    },
    processStatus: {
      type: String,
      default: 'process',
      validator: (val: string): boolean =>
        ['wait', 'process', 'finish', 'error', 'success'].includes(val),
    },
  },
  emits: [CHANGE_EVENT],
  setup(props, { emit }) {
    const steps = ref<any>([])
    watch(steps, () => {
      steps.value.forEach((instance, index) => {
        instance.setIndex(index)
      })
    })

    const isVertical = computed(() => {
      return props.direction === 'vertical'
    })

    provide('MsSteps', { props, steps })
    watch(
      () => props.active,
      (newVal, oldVal) => {
        emit(CHANGE_EVENT, newVal, oldVal)
      },
    )
    return {
      steps,
      isVertical,
    }
  },
})
</script>

<template>
  <div :class="isVertical ? '' : 'flex flex-center'">
    <slot />
  </div>
</template>

<style scoped>

</style>
